/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2023-07-26 08:00:56
 *
 *******************************************************/
//@flow
import React from 'react';
import { RadioButton } from '@shopify/polaris';

export const RenderSuggestionStyle = (field: Object) => {
  return (
    <RadioButton
      name={field.input.name}
      id={field.id}
      label={field.label}
      checked={field.input.value === field.id}
      onChange={(checked: boolean, newValue: string, e) => {
        field.onChangeValue(newValue);
      }}
    />
  );
};
